<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { Separator as SeparatorRoot, type SeparatorProps as SeparatorRootProps } from 'reka-ui'
import { cn } from '@/lib/utils'

const props = withDefaults(
    defineProps<SeparatorRootProps & { class?: HTMLAttributes['class'] }>(),
    {
        orientation: 'horizontal',
        decorative: true,
    },
)
</script>

<template>
    <SeparatorRoot
        v-bind="props"
        :class="
            cn(
                'shrink-0 bg-border',
                props.orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px',
                props.class,
            )
        "
    />
</template>
